import { createSlice, isAction } from "@reduxjs/toolkit";
import {
  fetchMakeById,
  fetchMakes,
  updateMake,
  updateStatusInMake,
} from "./thunk";

interface MakeState {
  makeList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedMake: any;
}

const initialState: MakeState = {
  makeList: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedMake: null,
};

const makeSlice = createSlice({
  name: "make",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMakes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMakes.fulfilled, (state, action) => {
        state.loading = false;
        state.makeList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchMakes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch packages";
      })
      .addCase(fetchMakeById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMakeById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedMake = action.payload;
      })
      .addCase(fetchMakeById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(updateMake.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.makeList = state.makeList.map((dist) =>
          dist.id === action.payload.id ? action.payload : dist
        );
      })
      .addCase(updateMake.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update packages";
      })
      .addCase(updateStatusInMake.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        // state.makeList = state.makeList.map((dist) =>
        //   dist.id === action.payload.id ? action.payload : dist
        // );
      })
      .addCase(updateStatusInMake.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch packages";
      });
  },
});

export default makeSlice.reducer;
